export default __webpack_public_path__ + "static/media/company_website.f1c5075e.svg";